import { setupStore } from './setup';

export const store = setupStore();
